import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { ChangeEventHandler } from 'react';
import { ItemWithLabel } from '../utils';
import FieldWrapper, { FieldWrapperProps } from './FieldWrapper';

export default function RadioField({
  name,
  onBlur,
  onChange,
  options,
  value,
  ...rest
}: RadioFieldProps) {
  return (
    <FieldWrapper {...rest}>
      <RadioGroup
        aria-label={rest.label}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
      >
        {options.map((option) => (
          <FormControlLabel
            control={<Radio />}
            key={option.value}
            label={option.label as any}
            value={option.value}
          />
        ))}
      </RadioGroup>
    </FieldWrapper>
  );
}

export interface RadioFieldProps extends Omit<FieldWrapperProps, 'onChange'> {
  name?: string;
  onBlur?: ChangeEventHandler;
  onChange?: ChangeEventHandler;
  options: ItemWithLabel[];
  value?: any;
}
